<template>
	<div class="cont_boardlist article_more_board" :class="rootClass" :style="rootStyle" v-show="showArticles">
		<strong class="screen_out">하단 게시글 목록</strong>

		<search-title v-if="isSearch" :query="query" :isNicknameSearch="isNicknameSearch"/>
		<common-title v-else :title="title" :description="description"/>

		<album-article-list v-if="isAlbum"/>
		<common-article-list v-else/>

		<div class="move_top" v-if="showsMoveTopBtn">
			<a href="#"><span class="ico_bbs ico_top"></span>맨위로</a>
		</div>

		<layer-manager/>
	</div>
</template>

<script>
import SearchTitle from './components/SearchTitle.vue';
import CommonTitle from './components/CommonTitle.vue';
import AlbumArticleList from './components/AlbumArticleList.vue';
import CommonArticleList from './components/CommonArticleList.vue';
import LayerManager from '../components/layer/LayerManager.vue';
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
	components: {
		SearchTitle, CommonTitle, AlbumArticleList, CommonArticleList, LayerManager
	},
	computed: {
		...mapState(['query', 'isNicknameSearch', 'title', 'description', 'articles']),
		...mapGetters(['isSearch', 'isAlbum']),
		rootClass() {
			return {
				search_result: this.isSearch
			};
		},
		rootStyle() {
			return {
				display: 'block'
			};
		},
		// 댓글내용, 댓글작성자 검색일 경우 검색결과가 내려오지 않음
		// 이 경우 하단 게시글 목록 영역을 감추기
		showArticles() {
			return !this.loading && (!this.isSearch || this.articles.length > 0);
		}
	},
	data() {
		return {
			loading: true,

			showsMoveTopBtn: false,
			MIN_HEIGHT: 800
		};
	},
	methods: {
		...mapActions(['fetchArticles'])
	},
	async created() {
		await this.fetchArticles();
		this.loading = false;

		await this.$nextTick();

		const primaryContent = document.getElementById('primaryContent');
		if (primaryContent.clientHeight >= this.MIN_HEIGHT) {
			this.showsMoveTopBtn = true;
		}
	}
}
</script>
